<!-- @format -->
<template>
    <post-hv-news v-if="this.$route.name === 'hvnews'"
        :post="post"
        pixelated-media
        :is-top-post="isTopPost"
        :show-snippet="false"
        @single-post-view="$emit('single-post-view', $event)"
    />
    <post v-else
        :post="post"
        pixelated-media
        :is-top-post="isTopPost"
        :show-snippet="false"
    />
</template>

<script>
import Post from './Post.vue';
import PostHvNews from './PostHvNews.vue';

export default {
    components: {
        Post,
        PostHvNews
    },
    props: {
        post: {
            type: Object,
            required: true
        },
        isTopPost: {
            type: Boolean,
            default: false
        }
    }
};
</script>
